import axios from 'axios'
import { endpoints } from './endpoints';

const chatEndpoints = endpoints.chat;

export function getAll() {
  return axios.get(chatEndpoints.getAll())
}

export function deleteAll() {
  return axios.delete(chatEndpoints.deleteAll())
}

export function updateName(chatId: string, name: string) {
  return axios.patch(chatEndpoints.updateName(chatId), {name})
}

export function deleteChat(chatId: string) {
  return axios.delete(chatEndpoints.delete(chatId))
}

export function getSharedChat(chatId?: string, sharedChatId?: string) {
  return axios.get(chatEndpoints.getShared(chatId, sharedChatId))
}

export function share(chatId: string) {
  return axios.post(chatEndpoints.share(chatId))
}

export function unshare(chatId: string) {
  return axios.delete(chatEndpoints.share(chatId))
}

export function updateSharing(chatId: string){
  return axios.patch(chatEndpoints.share(chatId))
}

export async function recognizeSpeech(chatId: string, blob: Blob): Promise<string> {
  const formData = new FormData()
  formData.append("audio", blob, "recording.wav")
  const response = await axios.post(chatEndpoints.recognizeSpeech(chatId), formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return response.data.data['text'];
}